// extracted by css-extract-rspack-plugin
export default {"error":"Error__error--IdHu7"};